export const pl_PL = {
  translation: {
    add_to_cart: "Dodaj artykuł do koszyka",
    save: "Zapisz",
    load: "Załaduj artykuł",
    title: "Konfiguracja",
    type_key: "Klucz typu",
    start: "Start",
    generate_document: "Utwórz kartę danych",
    sap_button: "Utwórz artykuł w SAP",
    cad_button: "Utwórz dane CAD",
    reset_configuration: "Resetuj konfigurację",
    show_additional_information: "Pokaż dodatkowe informacje",
    sap_title: "SAP",
    close_configuration_button: "Zamknij",
    no_results_found: "Brak wyników",
    newId_button: "Utwórz nowy GUID",
    load_configuration_dialog: {
      title: "Załaduj konfigurację – Ustaw parametry wyszukiwania",
      cancel: "Anuluj",
      search: "Szukaj",
      start_date: "Data utworzenia od",
      end_date: "do",
      guid: "GUID",
      material_number: "Numer materiału",
      order_code: "Kod zamówienia",
      creator: "Twórca",
      description: "Opis",
      info_artikel: "Artykuł informacyjny",
      short_text: "Krótki tekst",
      version: "Wersja",
      status: "Status",
      update_user: "Zaktualizowane przez",
      createdDate: "Data utworzenia",
      saved_records: "Zapisane rekordy",
      back: "Wstecz",
      open: "Otwórz",
      rows_per_page: "Wiersze na stronę:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(ŁADOWANIE) nie powiodło się (dane nieprawidłowe lub niekompletne)",
      ERROR_SAVE_DATA_ERROR:
        "(ZAPIS) nie powiodło się (dane nieprawidłowe lub niekompletne)",
      ERROR_LOAD_ID: "Nie znaleziono ID do załadowania",
      ERROR_LOAD_ID_CONFIG: "Błąd konfiguratora podczas ładowania projektu",
      ERROR_LOADSTART_CONFIG: "Błąd konfiguratora przy uruchamianiu",
      ERROR_MISSING_VALUES:
        "Ogólny komunikat o błędzie, jeśli walidacja danych frontendowych nie powiodła się",
      ERROR_COOKIE_SERVICE_INITIAL:
        "Inicjalizacja usługi cookie nie powiodła się",
      ERROR_COOKIE_GENERAL: "Błąd w usłudze cookie",
      ERROR_TOKEN_NOT_FOUND: "Token nie znaleziony",
      ERROR_ID_BLOCKED: "Element jest edytowany, zmiany niemożliwe",
      ERROR_DB_SAVE: "Błąd podczas zapisywania danych w bazie danych",
      ERROR_LOAD_VALID:
        "Ładowanie konfiguracji nie powiodło się, dane są nieprawidłowe",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "Nie znaleziono ID, kontrola SAP nie powiodła się",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Nie znaleziono numeru materiału dla ID z shop-ID",
      ERROR_DELETE_CONFIGURATION: "Błąd podczas usuwania konfiguracji",
      ERROR_DEFINITION_SECRET_JWT: "Brak definicji JWT",
      ERROR_PATH_NOT_DEFINED: "Ścieżka nie została zdefiniowana",
      ERROR_BACKLINK_URL: "Backlink-URL nie został zdefiniowany",
      ERROR_POSITIONDATA_EMPTY: "Dane pozycji są puste",
      ERROR_SHOP_ID: "ID sklepu nie znaleziono",
      ERROR_CADBOXDATA_EMPTY: "Nie znaleziono danych CAD box",
      ERROR_NONE_LOAD_ID_FOUND: "Nie znaleziono ID do załadowania",
      ERROR_NONE_ACCEPTABLE_ID: "Nie znaleziono akceptowalnego ID",
    },
    sap: {
      create_error: "Błąd podczas tworzenia",
      create_success: "Pomyślnie utworzono",
    },
    session_expired: {
      title: "⚠️ Sesja została przerwana",
      text: "Sesja została zakończona z powodu braku aktywności. Proszę uruchomić konfigurator ponownie.",
    },
    button: {
      save: "Zapisz",
      cancel: "Anuluj",
    },
  },
};

export default pl_PL;
